import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const KeyLimitTopBannerAlert = lazy(() => import('.'));

const RootProviders = lazy(() => import('@app/components/AppProviders'));

class KeyLimitTopBannerAlertWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['plan-id', 'key-limit', 'key-count', 'team-uuid'];
    }

    render() {
        const planId = Number(this.prop('plan-id'));
        const keyLimit = Number(this.prop('key-limit'));
        const keyCount = Number(this.prop('key-count'));
        const teamUuid = this.prop('team-uuid');

        return (
            <RootProviders>
                <KeyLimitTopBannerAlert planId={planId} keyLimit={keyLimit} keyCount={keyCount} teamUuid={teamUuid} />
            </RootProviders>
        );
    }
}

customElements.define('key-limit-top-banner-alert', KeyLimitTopBannerAlertWebComponent);
